module.exports = __webpack_public_path__ + "img/龙椅·正襟危坐 v2.270d2647.png";